import React from 'react';
import { css, useTheme } from '@emotion/react';
import { type CSSInterpolation } from '@emotion/serialize';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

type Props = {
  customStyles?: CSSInterpolation;
};
const SimpleModalTitle: ReactFCC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const { children, customStyles } = props;

  const baseStyles = css({
    fontSize: '2rem',
    lineHeight: '44px',
    fontWeight: 'bold',
    padding: '15px 40px 0 0',
  });

  const titleThemeStyles = css({
    color: theme.titleFontColor || theme.primaryColor,
    fontWeight: theme.titleFontWeight,
    fontSize: theme.titleFontSize,
    fontFamily: theme.titleFontFamily,
    textTransform: theme.titleTextTransform,
  });

  return (
    <div
      className="bbk-simple-modal-title"
      css={[baseStyles, titleThemeStyles, css(customStyles)]}
    >
      {children}
    </div>
  );
};

export default SimpleModalTitle;
